import { FormLabel, Grid, List, ListItem, Typography } from "@mui/material";
import React, { useState } from "react";

import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormColorTC from "../../../components/Forms/FormColorTC";
import ImageUuids from "../ImageUuids";
import { Alert } from "@mui/lab";
import { CheckCircle } from "@mui/icons-material";
import { ImageResolutionHint } from "../../../components/ImageHints/ImageResolutionHint";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormTextTC from "../../../components/Forms/FormTextTC";

function ImageHints() {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Alert
        onClick={() => setOpened(!opened)}
        severity={"info"}
        style={{
          "&:hover": {
            cursor: "pointer",
          },
          marginTop: "8px",
          marginBottom: "8px",
        }}
      >
        <TranslationWrapper
          tDefault={"Want your product photos to look perfect? Click here to learn how."}
          tKey={"image.hints.product.click-here"}
        />
      </Alert>
      {opened ? (
        <Card>
          <List>
            <ListItem>
              <Typography style={{ display: "flex" }}>
                <CheckCircle style={{ fill: "#4caf50", marginRight: "4px" }} />
                <TranslationWrapper tDefault={"My image is 600x600"} tKey={"image.hints.product.resolution-hint"} />
              </Typography>
            </ListItem>
            <ListItem>
              <Typography style={{ display: "flex" }}>
                <CheckCircle style={{ fill: "#4caf50", marginRight: "4px" }} />
                <TranslationWrapper
                  tDefault={"The product is centered in the image"}
                  tKey={"image.hints.product.centered-hint"}
                />
              </Typography>
            </ListItem>
            <ListItem>
              <Typography style={{ display: "flex" }}>
                <CheckCircle style={{ fill: "#4caf50", marginRight: "4px" }} />
                <TranslationWrapper
                  tDefault={"The background is transparent"}
                  tKey={"image.hints.product.transparency-hint"}
                />
              </Typography>
            </ListItem>
          </List>
        </Card>
      ) : null}
    </>
  );
}

function Branding() {
  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody>
          <Grid container spacing={1}>
            <Grid item lg={6} xs={12}>
              <FormColorTC
                name={"fontColor"}
                nullable={true}
                tDefault={"Fontcolor"}
                tKey={"producten.form.algemeen.label.fontColor"}
              />
              <FormColorTC
                name={"bgColor"}
                nullable={true}
                tDefault={"Background colour"}
                tKey={"producten.form.algemeen.label.bgColor"}
              />
              <FormControlledInputTC
                name={"custom_data.number_of_columns"}
                nullable={true}
                tDefault={"Number of columns"}
                tKey={"custom_data.number_of_columns"}
                type={"number"}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <Grid item xs={12}>
                <FormLabel>
                  <TranslationWrapper
                    tDefault={"Afbeelding(en)"}
                    tKey={"producten.form.branding.afbeelding.label.imgid"}
                  />
                  {/* eslint-disable-next-line react/jsx-no-undef */}
                  <ImageResolutionHint res={"600x600"} />
                  <ImageHints />
                </FormLabel>
                <ImageUuids />
                {/*<FormFile type={"image"} nullable={true} name={"imgid"} />*/}
                {/*<FormFile type={"gif"} nullable={true} canCrop={false} name={"gif"} />*/}
              </Grid>
            </Grid>

            <Grid item lg={6} xs={12}>
              <FormTextTC
                fieldProps={{ multiline: true, rows: 5 }}
                name={"custom_data.box_tooltip.custom_html"}
                nullable={true}
                tDefault={"Add custom html to top of product on menu page"}
                tKey={"Add custom html to top of product on menu page"}
              />
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}

export default Branding;
